import {isDev} from "../functions";

export default (
    isDev
        ? require('../otherChains/monadTestnet').default.rpcUrls.default.http[0]
        : 'https://icy-attentive-film.monad-testnet.quiknode.pro/8b50ba5cd0e17541a86ff1c0e358f3c2fb5e57e8/'//'https://monad-testnet.g.alchemy.com/v2/qupTO2ZW5SVtfWvlzUf2LsjXp_-MfgCl'
)
// 'https://white-distinguished-card.monad-testnet.quiknode.pro/0ee0e7002caf8bd6a06e9a038cf56e2785d1a015'